import { Component, Inject, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

export interface ExcelTabSelectorData {
  tabs: string[];
}

@Component({
  selector: 'app-excel-tab-selector',
  templateUrl: './excel-tab-selector.component.html',
  styleUrls: ['./excel-tab-selector.component.scss']
})
export class ExcelTabSelectorComponent {
  selectedTab: string;

  constructor(
    public dialogRef: MatDialogRef<ExcelTabSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExcelTabSelectorData
  ) {
    if (data.tabs && data.tabs.length > 0) {
      this.selectedTab = data.tabs[0];
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedTab);
  }
}

@NgModule({
  declarations: [ExcelTabSelectorComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatIconModule
  ]
})
export class ExcelTabSelectorModule {} 